import { useContext } from "react";
import { MenuContext } from "../context/MenuContext";

export function useMenuConfig() {
    return useContext(MenuContext);
}
